<script>
  import { onMount } from "svelte"
  import { session, gameId, me } from "../store"
  import Shell from "./Shell.svelte"
  import Count from "./Count.svelte"
  import play from "../lib/play"
  import RoundStatus from "./RoundStatus.svelte"
  import punct from "../lib/punct"

  export let sentence = ""
  let submissions = []
  export let blanks = []
  let winner = { words: [] }
  let votes = {}
  let timo = 0
  let voteCount = 0
  let runnerups = []
  onMount(() => setTimeout(() => play("happy"), 500))
  $: {
    let votesBySubmission = {}
    const values = $session.votes[$session.onSentence]
      ? $session.votes[$session.onSentence]
      : []
    submissions = $session.submissions[`${$session.onSentence}`]
    votesBySubmission = Object.entries(values).reduce((out, [key, val]) => {
      if (out[val]) out[val] += 1
      else out[val] = 1
      return out
    }, {})
    votes = Object.entries(votesBySubmission)
      .map(([key, val]) => {
        let inx = 0
        return {
          submission: submissions[key],
          participant: $session.participants[key],
          name: $session.participants[key].name,
          words: fillSentence(submissions[key].submission),
          votes: val,
        }
      })
      .sort((a, b) => {
        if (a.votes > b.votes) return -1
        if (a.votes < b.votes) return 1
        if (+a.submission.stamp.seconds < +b.submission.stamp.seconds) return -1
        if (+a.submission.stamp.seconds > +b.submission.stamp.seconds) return 1
        if (+a.submission.stamp.nanoseconds < +b.submission.stamp.nanoseconds)
          return -1
        if (+a.submission.stamp.nanoseconds > +b.submission.stamp.nanoseconds)
          return 1
        if (a.submission.submission[0] < b.submission.submission[0]) return -1
        if (a.submission.submission[0] > b.submission.submission[0]) return 1
      })
      .slice(0, 7)
    winner = votes[0]
    runnerups = votes.slice(1)
  }
  function fillSentence(fills) {
    let inx = 0
    let matches = sentence.match(punct)
    const parts = sentence
      .replace(new RegExp(`[${matches[0].split("").join("\\")}]$`), "")
      .split(" ")
      .map((content) => {
        if (content[0] === "%") {
          inx += 1
          return {
            content: fills
              ? fills[inx - 1]
              : blanks[+content.replace("%blank-", "")],
            type: "input",
          }
        }
        return {
          type: "word",
          content,
        }
      })
    parts.push({ type: "word", content: matches[0] })
    return parts
  }
</script>

<style lang="scss">
  @import "../vars";
  input {
    margin: 0 0.3rem;
  }
  .winner {
    label {
      margin-bottom: 5rem;
      font-size: 1.1rem;
      span {
        font-size: 1rem;
      }
    }
  }
  .sentenceWrap {
    padding: 2rem;
    background: l($gray, 60%);
    position: relative;
    display: flex;
    img {
      width: 4.5rem;
      object-fit: contain;
      margin-right: 2rem;
      opacity: 0.6;
      flex: none;
      svg {
        fill: $orange;
        stroke: $orange;
      }
    }
  }
  .sentence {
    font-size: 1.3rem;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    line-height: 170%;
  }
  .options {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 1rem;
    margin-top: 1rem;
  }
  .selected {
    background: $red;
    color: $white;
  }
  .filled {
    background: l($red, 90%);
    border: 1px dashed l($red, 70%);
    padding: 0.3rem 0.6rem;
    margin: 0 0.3rem 0 0.1rem;
    line-height: 110%;
    height: 2.2rem;
  }
  label {
    font-weight: normal;
    margin-top: 1rem;
    font-size: 0.9rem;
    width: 100%;
    display: block;
    span {
      font-size: 0.85rem;
      background: l($green, 10%);
      color: $white;
      padding: 0.25rem 0.5rem 0.3rem 0.5rem;
      font-weight: 400;
      margin-right: 0.5rem;
    }
  }
  .mention {
    padding: 1rem;
    background: l($gray, 60%);
    margin-bottom: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    line-height: 160%;
    .filled {
      height: 1.7rem;
      margin-top: -1px;
    }
    label {
      margin-top: 0.6rem;
      padding-top: 0.4rem;
      border-top: 1px solid #ededed;
    }
  }
  h3 {
    display: flex;
    align-items: center;
    margin-top: 2.5rem;
    margin-bottom: 1rem;
    img {
      width: 2rem;
      object-fit: contain;
      opacity: 0.6;
      margin-right: 0.7rem;
    }
  }
  button {
    background: $gray;
    border: 0;
    padding: 0.6rem;
    display: block;
    cursor: pointer;
  }
</style>

<div>
  {#if winner}
    <h2>
      Woohoo, congrats to {winner.name}! Their entry won with {winner.votes} {+winner.votes === 1 ? 'vote' : 'votes'}!
    </h2>
    <Shell>
      <div class="winner">
        <div class="sentenceWrap">
          <img src="/icons/trophy1.svg" />
          <div class="sentence">
            {#each winner.words as word}
              {#if word.type === 'input'}
                <span class="filled">{word.content}</span>
              {:else}
                <span>{word.content}&nbsp;</span>
              {/if}
            {/each}
          </div>
        </div>
        <label>
          <span>{winner.votes} {+winner.votes === 1 ? 'vote' : 'votes'}</span>
          Submitted by {winner.name}
        </label>
      </div>
      <h3>
        <img src="/icons/badge1.svg" />
        Honorable Mentions
      </h3>
      <div class="mentions">
        {#each runnerups as v}
          <div class="mention">
            {#each v.words as word}
              {#if word.type === 'input'}
                <span class="filled">{word.content}</span>
              {:else}
                <span>{word.content}&nbsp;</span>
              {/if}
            {/each}
            <label>
              <span>{v.votes} {+v.votes === 1 ? 'vote' : 'votes'}</span>
              Submitted by {v.name}
            </label>
          </div>
        {/each}
      </div>
    </Shell>
    <RoundStatus>
      <Count pre="Next Round In" />
    </RoundStatus>
  {:else}
    <h2>No winner?</h2>
  {/if}
</div>
